import type { CSSObject } from '@emotion/react';

export const loadingIndicator = (baseCSS: CSSObject): CSSObject => ({
  ...baseCSS,
  paddingRight: 0,
});
